<template>
	<div class="mgs-plain-statbox flex-grow">
		<div class="flex-grow">{{ partialTitle }}: {{ partialValue }}</div>
		<div v-if="statsGraphic != undefined" class="mgs-stats-graphic">
			<div class="mgs-stats-graphic-inner" :style="`width:${graphicWidth}%`"></div>
		</div>
	</div>
</template>
<script>
export default {
	name: "StatisticsPartialsPlain",
	props: {
		partialTitle: {
			type: String,
			required: true
		},
		partialValue: {
			type: [String, Number],
			required: true
		},
		statsGraphic: {
			type: Object
		}
	},
	computed: {
		graphicWidth() {
			if (this.statsGraphic != undefined) {
				if (this.statsGraphic.percentage) return this.statsGraphic.percentage;
				if (this.statsGraphic.total && this.statsGraphic.outOf) return ((this.statsGraphic.total / this.statsGraphic.outOf) * 100).toFixed(2);
			}
			return 0;
		}
	}
}
</script>
<style lang="scss">
.mgs-plain-statbox {
	@apply mt-1;
}
.mgs-stats-graphic {
	width: 100%;
	margin: 5px 0;
	height:20px;
	border: 1px solid;
	border-radius: 4px;
	.mgs-stats-graphic-inner {
		@apply bg-forest-green;
		height: 100%;
		transition: width 0.3s ease;
		border-radius: 4px;
	}
}
</style>
